import { Tooltip } from "antd";
import { useState } from "react";
import copy from "../assets/Images/Copy.svg";

interface DataType {
  copyText: string;
}

const ClipboardCopy = ({ copyText }: DataType) => {
  const [isCopied, setIsCopied] = useState(false);

  // This is the function we wrote earlier
  async function copyTextToClipboard(text: string) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <span className="cursor_pointer" onClick={handleCopyClick}>
        <Tooltip title={isCopied ? "Copied!" : ""}>
          <img src={copy} alt=""></img>
        </Tooltip>
        {/* {isCopied ? "Copied!" : ""} */}
      </span>
    </div>
  );
};

export default ClipboardCopy;
